import React from 'react';
import './header-drawer.scss';
import {SettingsLangDrawerComponent} from '../setttings/settings-lang-drawer.component';

import {SocialNetworkWrapper} from '../social-network-wrapper/social-network-wrapper.component';
import {CloseDrawer} from '../close-drawer/close-drawer.component';
import {useSpring, animated} from 'react-spring';
import SearchDrawerComponent from '../search-drawer/search-drawer.component';

export const HeaderDrawer = ({drawerType, drawerOpen, setDrawerOpen}: any) => {
    const {transform, opacity} = useSpring({
        transform: drawerOpen ? 'translate3D(0,-0px,0)' : 'translate3D(0,-400px,0)',
        opacity: drawerOpen ? 1 : 0,
        config: {tension: 200, friction: 30},
    });


    return (
        <animated.div
            className='header-drawer-div'
            style={{
                transform,
                opacity,
                position: 'fixed',
                top: 45,
                width: '100%',
                zIndex: 1,
                overflow: 'hidden',
            }}
        >
            {drawerType === 'search' && <SearchDrawerComponent />}
            {drawerType === 'lang' && <SettingsLangDrawerComponent />}
            {drawerType === 'media' && <SocialNetworkWrapper />}
            <CloseDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
        </animated.div>
    );
};
